
<template>
    <b-row class="my-3">
        <template v-if="isSavingProject || isDeletingProject">
            <b-col cols="12">
                <b-spinner variant="primary" label="Spinning" class="mb-3"></b-spinner>
                <div v-show="isSavingProject || isDeletingProject">
                    {{ `프로젝트를 ${isSavingProject ? '저장' : '삭제'}하고 있습니다. 잠시만 기다려주세요.` }}
                </div>
            </b-col>
        </template>
        <template v-else>
            <b-col cols="12" class="mb-4">
                <h5 class="">프로젝트 상태관리</h5>
                <div :class="[{'border border-danger border-width-2': projectInfoFormState.pay === false || projectInfoFormState.availability === false || projectInfoFormState.self_assessment === false || projectInfoFormState.vendor_code === false },
                    {'border border-color-gray-300 border-width-1': projectInfoFormState.pay !== false || projectInfoFormState.availability !== false || projectInfoFormState.self_assessment === false || projectInfoFormState.vendor_code !== false },
                    'bg-white rounded-sm p-4']"
                    >
                    <b-row class="justify-content-md-between">
                        <b-col cols="6" md="auto">
                            <b-form-group
                                label="*유료코드"
                                v-slot="{ ariaDescribedby }"
                                :label-class="[{'text-danger fw-600': projectInfoFormState.pay === false }, 'mb-0']"
                                :state="projectInfoFormState.pay"
                                invalid-feedback="선택해주세요"
                                >
                                <b-form-radio-group
                                    id="project-info-pay"
                                    v-model="projectInfo.pay"
                                    :options="options"
                                    :aria-describedby="ariaDescribedby"
                                    :button-variant="!projectInfo.pay ? 'outline-danger' : 'outline-success'"
                                    size="sm"
                                    name="project-info-pay"
                                    buttons
                                    >
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6" md="auto">
                            <b-form-group
                                label="*코드사용"
                                v-slot="{ ariaDescribedby }"
                                :label-class="[{'text-danger fw-600': projectInfoFormState.availability === false }, 'mb-0']"
                                :state="projectInfoFormState.availability"
                                invalid-feedback="선택해주세요"
                                >
                                <b-form-radio-group
                                    id="project-info-availability"
                                    v-model="projectInfo.availability"
                                    :options="options"
                                    :aria-describedby="ariaDescribedby"
                                    :button-variant="!projectInfo.availability ? 'outline-danger' : 'outline-success'"
                                    size="sm"
                                    name="project-info-availability"
                                    buttons
                                ></b-form-radio-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6" md="auto">
                            <b-form-group
                                label="*자가진단"
                                v-slot="{ ariaDescribedby }"
                                :label-class="[{'text-danger fw-600': projectInfoFormState.self_assessment === false }, 'mb-0']"
                                :state="projectInfoFormState.self_assessment"
                                invalid-feedback="선택해주세요"
                                >
                                <b-form-radio-group
                                    id="project-info-self-assessment"
                                    v-model="projectInfo.self_assessment"
                                    :options="options"
                                    :aria-describedby="ariaDescribedby"
                                    :button-variant="!projectInfo.self_assessment ? 'outline-danger' : 'outline-success'"
                                    size="sm"
                                    name="project-info-self-assessment"
                                    buttons
                                ></b-form-radio-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6" md="auto">
                            <b-form-group
                                label="*업체 코드"
                                v-slot="{ ariaDescribedby }"
                                :label-class="[{'text-danger fw-600': projectInfoFormState.vendor_code === false }, 'mb-0']"
                                :state="projectInfoFormState.vendor_code"
                                invalid-feedback="선택해주세요"
                                >
                                <b-form-radio-group
                                    id="project-info-vendor-code"
                                    v-model="projectInfo.vendor_code"
                                    :options="options"
                                    :aria-describedby="ariaDescribedby"
                                    :button-variant="!projectInfo.vendor_code ? 'outline-danger' : 'outline-success'"
                                    size="sm"
                                    name="project-info-vendor-code"
                                    buttons
                                ></b-form-radio-group>
                            </b-form-group>
                        </b-col>
                        <!--
                            AI 자동승인: 기존 4개 토글과 반대로 "꺼짐"이 안전한 기본값이다.
                            그래서 위 컨테이너의 border-danger 강조 조건(라인 15-16)에는 넣지 않고,
                            대신 켜졌을 때만 이 컬럼 안에서 danger 색상 + 경고 문구로 눈에 띄게 한다.
                            저장 경로도 분리되어 있다 — PUT /project_code 가 아니라 전용 엔드포인트를
                            즉시 호출한다(#189, projectInfo 에 얹으면 백엔드가 조용히 무시함).
                        -->
                        <b-col cols="6" md="auto" v-if="edit && can_manage_ai_auto_approve">
                            <b-form-group
                                label="AI 자동승인"
                                v-slot="{ ariaDescribedby }"
                                :label-class="[{'text-danger fw-600': aiAutoApprove}, 'mb-0']"
                                description="켜면 AI 평가 결과가 평가자 확인 없이 바로 반영됩니다. 변경 즉시 저장됩니다(수정하기 버튼과 별개)."
                                >
                                <b-form-radio-group
                                    id="btn-radios-ai-auto-approve"
                                    :key="aiRadioKey"
                                    :checked="aiAutoApprove"
                                    :options="options"
                                    :aria-describedby="ariaDescribedby"
                                    :button-variant="aiAutoApprove ? 'outline-danger' : 'outline-secondary'"
                                    :disabled="isLoadingAiAutoApprove || isSavingAiAutoApprove"
                                    size="sm"
                                    name="radio-btn-outline-ai-auto-approve"
                                    buttons
                                    @change="onToggleAiAutoApprove"
                                ></b-form-radio-group>
                                <div v-if="aiAutoApprove" class="text-danger f-75 fw-600 mt-1">
                                    <AppIcon name="alert-triangle" class="mr-1"/>자동승인 켜짐 — 평가자 확인 없이 즉시 반영됩니다
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
            <b-col cols="12" class="mb-4">
                <h5 class="">프로젝트 기본정보</h5>
                <div class="bg-white border border-color-gray-300 border-width-1 rounded-sm p-4">
                    <b-row>
                        <b-col cols="12" md="6" xl="4" class="mb-3">
                            <b-form-group label-for="project-info-code"
                                label="*프로젝트 코드"
                                description="사용할 프로젝트 코드를 입력해주세요."
                                :state="projectInfoFormState.project_code"
                                invalid-feedback="필수 입력입니다"
                                >
                                <b-form-input id="project-info-code"
                                    v-model.trim="projectInfo.project_code"
                                    :state="projectInfoFormState.project_code"
                                    placeholder="사용할 프로젝트 코드명"
                                    autofocus
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" xl="4" class="mb-3">
                            <b-form-group label-for="project-info-period"
                                label="*PERIOD"
                                description="프로젝트코드가 적용될 기간(PERIOD)를 입력해주세요."
                                :state="projectInfoFormState.period"
                                invalid-feedback="필수 입력입니다"
                                >
                                <!-- 기간이 바뀌면(칸을 벗어날 때) 그 기간의 캠페인으로 선택지를 바꾼다 -->
                                <b-form-input id="project-info-period"
                                    v-model.trim="projectInfo.period"
                                    list="project-periods-list"
                                    :state="projectInfoFormState.period"
                                    placeholder="프로젝트 코드 적용 기간(PERIOD)"
                                    @change="onPeriodChange"
                                />

                                <datalist id="project-periods-list">
                                    <option v-for="(period, p) in periods"
                                        :key="`project-edit-periods-${p}-${period}`"
                                        >
                                        {{ period }}
                                    </option>
                                </datalist>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" xl="4" class="mb-3">
                            <b-form-group label-for="project-info-manager"
                                label="*매니저"
                                description="프로젝트를 관리하는 매니저(QESG, NICE 등)를 입력해주세요."
                                :state="projectInfoFormState.manager"
                                invalid-feedback="필수 입력입니다"
                                >
                                <b-form-input id="project-info-manager"
                                    v-model.trim="projectInfo.manager"
                                    :state="projectInfoFormState.manager"
                                    placeholder="프로젝트 관리 매니저(QESG, NICE 등)"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" xl="4" class="mb-3">
                            <b-form-group label-for="project-info-campaign"
                                label="캠페인"
                                description="프로젝트에 연결할 캠페인을 선택해주세요."
                                :state="projectInfoFormState.campaign"
                                >
                                <!-- <b-form-input id="project-info-campaign"
                                    v-model="projectInfo.campaign"
                                    :state="projectInfoFormState.manager"
                                /> -->
                                <b-form-select id="project-info-campaign"
                                    v-model="projectInfo.campaign"
                                    :options="campaigns"
                                    value-field="id"
                                    text-field="campaign_name"
                                    />
                                <small v-if="campaigns_error" class="text-danger d-block mt-1">
                                    캠페인 목록을 불러오지 못했습니다.
                                    <b-link class="ml-1" @click="requestCampaigns">다시 시도</b-link>
                                </small>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" xl="4" class="mb-3">
                            <!--
                                평가 그룹: 이 프로젝트가 어느 프론트(서브도메인)의 평가 신청 화면에
                                노출되는지를 결정한다. 미지정이면 해당 프로젝트의 벤더코드가 신청
                                화면에서 조회되지 않는다(2026-07-23 운영 이슈). 코드를 직접 입력하면
                                오타가 조용한 미노출로 이어지므로 반드시 목록에서 선택하게 한다.
                            -->
                            <b-form-group label-for="project-info-project-group"
                                label="*평가 그룹"
                                :description="project_group_description"
                                :state="projectInfoFormState.project_group_id"
                                invalid-feedback="필수 입력입니다"
                                >
                                <b-form-select id="project-info-project-group"
                                    v-model="projectInfo.project_group_id"
                                    :options="project_group_options"
                                    :state="projectInfoFormState.project_group_id"
                                    />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" xl="4" class="mb-3">
                            <b-form-group label-for="project-info-client"
                                label="*원청사"
                                description="해당 프로젝트를 의뢰한 원청 기업을 입력해주세요."
                                :state="projectInfoFormState.client"
                                invalid-feedback="필수 입력입니다"
                                >
                                <b-form-input id="project-info-client"
                                    v-model.trim="projectInfo.client"
                                    list="project-info-client-list"
                                    :state="projectInfoFormState.client"
                                    placeholder="프로젝트 의뢰 원청 기업명"
                                />

                                <b-form-datalist id="project-info-client-list"
                                    :options="client_by_project"
                                    text-field="company_name"
                                    value-field="company_name"
                                    />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" xl="4" class="mb-3 mb-md-0">
                            <b-form-group label-for="project-info-dashboard"
                                label="대시보드 연결"
                                description="원청사 대시보드를 사용할 경우, 연결 기업의 company_id를 입력해주세요."
                                >
                                <b-form-input id="project-info-dashboard"
                                    v-model.number="projectInfo.client_id"
                                    list="project-info-dashboard-list"
                                    placeholder="프로젝트 의뢰 원청 기업 코드"
                                />

                                <b-form-datalist id="project-info-dashboard-list"
                                    :options="clients_by_id"
                                    text-field="company_name"
                                    value-field="company_id"
                                    />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" xl="12" class="mb-3 mb-md-0">
                            <b-form-group label-for="project-info-memo"
                                label="메모"
                                >
                                <b-form-textarea id="project-info-memo"
                                    v-model.trim="projectInfo.memo" 
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
            <b-col cols="12" class="mb-5">
                <h5 class="">프로젝트 기간 설정</h5>
                <div class="bg-white border border-color-gray-300 border-width-1 rounded-sm p-4">
                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-group label-for="project-info-startDate"
                                label="*시작일"
                                description="프로젝트 시작일을 선택해주세요."
                                :state="projectInfoFormState.start_date"
                                invalid-feedback="필수 입력입니다"
                                >
                                <b-form-datepicker
                                    id="project-info-startDate"
                                    v-model="projectInfo.start_date"
                                    :state="projectInfoFormState.start_date"
                                    placeholder="프로젝트 시작일"
                                    today-button
                                    class="mb-2"
                                    />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group label-for="project-info-endDate"
                                label="*종료일"
                                description="프로젝트 종료일을 선택해주세요."
                                :state="projectInfoFormState.end_date"
                                invalid-feedback="필수 입력입니다"
                                >
                                <b-form-datepicker
                                    id="project-info-endDate"
                                    v-model="projectInfo.end_date"
                                    :state="projectInfoFormState.end_date"
                                    placeholder="프로젝트 종료일"
                                    today-button
                                    class="mb-2"
                                    />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
            <b-col cols="12">
                <b-row>
                    <b-col cols="6">
                        <div class="text-left">
                            <b-btn v-if="edit"
                                variant="danger"
                                :disabled="!!project.availability"
                                @click="deleteProject"
                                >
                                프로젝트 삭제하기
                            </b-btn>
                            <small v-if="edit && project.availability" class="text-muted d-block mt-1">
                                사용중지(OFF)로 바꾸고 저장한 뒤 삭제할 수 있습니다
                            </small>
                        </div>
                    </b-col>
                    <b-col cols="6">
                        <div class="text-right">
                            <b-btn v-if="edit" 
                                variant="primary" 
                                class="mr-2" 
                                :disabled="!is_able_to_save"
                                @click="editProject"
                                >
                                프로젝트 수정하기
                            </b-btn>
                            <b-btn v-else
                                variant="primary" 
                                class="mr-2" 
                                :disabled="!is_able_to_save"
                                @click="addNewProject"
                                >
                                프로젝트 추가하기
                            </b-btn>
                            <b-btn variant="secondary"
                                :disabled="!is_able_to_save"
                                @click="resetProject"
                                >
                                초기화
                            </b-btn>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </template>
    </b-row>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage'
import unsavedChangesGuard from '@shared/mixin/unsaved-changes-guard'

// 필수 항목 → 입력 칸 id. 화면 위에서부터의 순서라 첫 빈 칸으로 이동할 때 쓴다
const REQUIRED_FIELD_IDS = {
    pay: 'project-info-pay',
    availability: 'project-info-availability',
    self_assessment: 'project-info-self-assessment',
    vendor_code: 'project-info-vendor-code',
    project_code: 'project-info-code',
    period: 'project-info-period',
    manager: 'project-info-manager',
    project_group_id: 'project-info-project-group',
    client: 'project-info-client',
    start_date: 'project-info-startDate',
    end_date: 'project-info-endDate'
}

const emptyFormState = () => ({
    campaign: null,
    pay: null,
    availability: null,
    self_assessment: null,
    vendor_code: null,
    project_code: null,
    period: null,
    manager: null,
    client: null,
    start_date: null,
    end_date: null,
    project_group_id: null
})

// 목록의 프로젝트 → 폼 값. 캠페인은 {id, name} 객체로 오지만 선택 칸은 id 를 쓴다
const toForm = (project) => ({
    ...project,
    campaign: project.campaign && typeof project.campaign === 'object' ? project.campaign.id : (project.campaign ?? null)
})

export default {
    name: 'ProjectAddUpdateModal',
    // 창 닫기·새로고침 시 미저장 입력 경고(모달 닫기는 AdminProjectCode 의 hide 가드가 confirmDiscardChanges 로 묻는다)
    mixins: [unsavedChangesGuard],
    props: {
        project: {
            type: Object,
            required: true
        },
        project_period: {
            type: String,
            required: true
        },
        edit: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            projectInfo: {},
            projectInfoFormState: emptyFormState(),
            project_groups: [],
            isSavingProject: false,
            isDeletingProject: false,
            options: [
                { value: true , text: 'ON' },
                { value: false, text: 'OFF', },
            ],
            periods: [],
            campaigns: [],
            campaigns_error: false,
            campaigns_loading: false,
            campaigns_token: 0,
            client_by_project: [],
            clients_by_id: [],

            // AI 자동승인 — projectInfo 와 별개 상태. PUT /project_code 로 저장되지 않고
            // 전용 엔드포인트로만 저장되므로(#189) projectInfo 에 절대 섞지 않는다.
            aiAutoApprove: false,
            aiRadioKey: 0,
            isLoadingAiAutoApprove: false,
            isSavingAiAutoApprove: false
        }
    },
    computed: {
        // 열 때 값과 비교한다(캠페인 객체/id 차이는 toForm 으로 맞춘 뒤)
        is_updated () {
            return JSON.stringify(this.projectInfo) !== JSON.stringify(toForm(this.project))
        },
        // 캠페인 선택지를 불러오는 중에는 이전 기간의 캠페인으로 저장되지 않게 막는다
        is_able_to_save () {
            return this.is_updated && !this.campaigns_loading
        },
        hasUnsavedChanges () {
            return this.is_updated && !this.isSavingProject && !this.isDeletingProject
        },
        is_admin () {
            return Number(this.$store.getters.isAdmin)
        },
        can_manage_ai_auto_approve () {
            return this.is_admin >= 3
        },
        project_group_options () {
            return [
                { value: null, text: '(평가 그룹을 선택해주세요)' },
                ...this.project_groups.map(_group => ({
                    value: _group.id,
                    text: `${_group.group_name} (${_group.group_code})`
                }))
            ]
        },
        selected_project_group () {
            return this.project_groups.find(_group => _group.id === this.projectInfo.project_group_id) || null
        },
        // 선택한 그룹에 어떤 값이 딸려 들어가는지(신청 화면 노출 기준 코드 / 보고서 엔진) 보여준다.
        project_group_description () {
            const _group = this.selected_project_group
            return _group
                ? `신청 화면 노출 기준: ${_group.group_code} / 보고서: ${_group.report_type || '기본(v2)'}`
                : '미지정 시 이 프로젝트의 벤더코드가 평가 신청 화면에서 조회되지 않습니다.'
        },
    },
    watch: {
        project: {
            deep: true,
            handler (_updated) {
                this.projectInfo = toForm(_updated)
                this.resetAiAutoApproveState(_updated)
            }
        }
    },
    async created () {
        this.projectInfo = toForm(this.project)

        // 하나가 실패해도 나머지 선택지는 채운다(각 함수가 실패를 토스트로 알린다)
        await Promise.all([
            this.requestCampaigns(),
            this.requestPeriods(),
            this.requestClients(),
            this.requestProjectGroups()
        ])
        await this.resetAiAutoApproveState(this.project)
    },
    methods:{
        checkIsFilledRequiredProjectfields() {
            if (this.isFieldEmpty(this.projectInfo.client_id)) {
                this.projectInfo.client_id = null
            }

            // Project Information Form Validation Check
            const _project_info_form_state = { ...this.projectInfoFormState }

            const stateFieldName = [ 'pay', 'availability', 'self_assessment', 'vendor_code' ]
            for (const fieldName of stateFieldName) {
                _project_info_form_state[fieldName] =
                    typeof this.projectInfo[fieldName] === 'undefined'
                        ? false
                        : null
            }

            const inputFieldName = [ 'project_code', 'period', 'manager', 'client', 'start_date', 'end_date', 'project_group_id' ]
            for (const fieldname of inputFieldName) {
                _project_info_form_state[fieldname] =
                    this.isFieldEmpty(this.projectInfo[fieldname])
                        ? false
                        : null
            }

            this.projectInfoFormState = _project_info_form_state
            return Object.values(_project_info_form_state).every(_field_state => _field_state === null)
        },
        // 빈 필수 칸은 칸 옆에 표시하고, 몇 개인지 알린 뒤 첫 빈 칸으로 이동한다
        validateRequired () {
            if (this.checkIsFilledRequiredProjectfields()) return true
            const missing = Object.keys(REQUIRED_FIELD_IDS).filter(key => this.projectInfoFormState[key] === false)
            this.$EventBus.$emit('toast-failure', '프로젝트 저장', `필수 항목 ${missing.length}개가 비어 있습니다.`)
            this.$nextTick(() => {
                const el = missing.length && document.getElementById(REQUIRED_FIELD_IDS[missing[0]])
                if (!el) return
                el.scrollIntoView({ block: 'center' })
                const target = el.matches('input, select, textarea, button') ? el : el.querySelector('input, select, textarea, button')
                if (target) target.focus()
            })
            return false
        },
        async addNewProject() {
            if (!this.validateRequired()) return false
            try {
                this.isSavingProject = true
                const response = await this.$axios.post('/project_code', this.projectInfo)
                this.$emit('update-project', response.data.project)
            } catch (error) {
                const status = error?.response?.status
                if (status === 401) return
                this.$EventBus.$emit('toast-failure', '프로젝트 저장', status === 409
                    ? '이미 생성된 프로젝트 코드입니다. 확인 후 다시 시도해주세요.'
                    : getErrorMessage(error, '프로젝트 생성을 실패했습니다. 다시 시도해주세요.'))
            } finally {
                this.isSavingProject = false
            }
        },
        async editProject() {
            if (!this.validateRequired()) return false
            try {
                this.isSavingProject = true
                const response = await this.$axios.put('/project_code', this.projectInfo)
                this.$emit('update-project', response.data.project)
            } catch (error) {
                const status = error?.response?.status
                if (status === 401) return
                // 실패해도 창을 닫지 않아 입력한 값이 남는다
                this.$EventBus.$emit('toast-failure', '프로젝트 저장', status === 404
                    ? '존재하지 않는 프로젝트입니다. 확인 후 다시 시도해주세요.'
                    : getErrorMessage(error, '프로젝트 수정을 실패했습니다. 다시 시도해주세요.'))
            } finally {
                this.isSavingProject = false
            }
        },
        async deleteProject () {
            // 저장된 값 기준 — 폼에서 OFF 로만 바꾸고 저장하지 않으면 잠금이 풀리지 않는다
            if (this.project.availability) {
                return false
            }
            const info = this.projectInfo
            const is_confirm_delete_project = await this.$showModal({
                type: 'confirm',
                state: 'error',
                title: '프로젝트 삭제',
                message: `${this.project.project_code} (${this.project.period || this.project_period}) 프로젝트${info.client ? ` · 고객사 ${info.client}` : ''}를 삭제합니다. 참여 신청이 1건이라도 있으면 삭제되지 않습니다. 삭제하면 되돌릴 수 없습니다.`
            })
            if (!is_confirm_delete_project) return false
            try {
                this.isDeletingProject = true
                const deleted_project = await this.$axios.delete(`/project_code/${this.project.project_code}`)
                this.$emit('delete-project', deleted_project.data.project)
            } catch (error) {
                const status = error?.response?.status
                if (status === 401) return
                this.$EventBus.$emit('toast-failure', '프로젝트 삭제', status === 409
                    ? '참여 신청이 있는 프로젝트라 삭제할 수 없습니다.'
                    : getErrorMessage(error, '프로젝트를 삭제하지 못했습니다. 다시 시도해주세요.'))
            } finally {
                this.isDeletingProject = false
            }
        },
        // 열 때 값으로 되돌린다(캠페인 연결 포함)
        resetProject () {
            this.projectInfo = toForm(this.project)
            this.projectInfoFormState = emptyFormState()
            // PERIOD 를 바꿨다 되돌린 경우 원래 기간의 캠페인 선택지로
            this.requestCampaigns()
        },
        async requestProjectGroups () {
            // 평가 그룹 선택지. 실패해도 폼 자체는 열리게 두되, 목록이 비면 저장 시
            // 필수검증에 걸려 사용자가 원인을 인지할 수 있다.
            try {
                const _res_groups = await this.$axios.get('/project_code/groups')
                this.project_groups = _res_groups.data || []
            } catch (error) {
                this.project_groups = []
                this.notifyLoadFailure(error, '평가 그룹 목록을 불러오지 못했습니다.')
            }
        },
        notifyLoadFailure (error, message) {
            if (error?.response?.status === 401) return
            this.$EventBus.$emit('toast-failure', '프로젝트 편집', message)
        },
        // 폼의 PERIOD 기준으로 캠페인 선택지를 불러온다. 기간이 없으면 조회하지 않는다.
        // 결과: true 성공 / false 실패 / null 더 새 조회가 있어 버림. 불러오는 동안은 저장을 막는다
        async requestCampaigns () {
            const token = ++this.campaigns_token
            const _period = this.projectInfo.period
            this.campaigns_error = false
            if (!_period) {
                this.campaigns_loading = false
                this.campaigns = [{ id: null, campaign_name: '(PERIOD 를 먼저 입력하세요)' }]
                return true
            }
            try {
                this.campaigns_loading = true
                const _res_campaigns = await this.$axios.get('/campaigns', { params: { period: _period } })
                if (token !== this.campaigns_token) return null
                let _campaigns = _res_campaigns.data.campaigns
                if (_campaigns) {
                    _campaigns.unshift({ id: null, campaign_name: '(캠페인 연결 없음)' })
                }
                this.campaigns = !_campaigns || !_campaigns.length ? null : _campaigns
                return true
            } catch (error) {
                if (token !== this.campaigns_token) return null
                this.campaigns_error = true
                this.notifyLoadFailure(error, '캠페인 목록을 불러오지 못했습니다.')
                return false
            } finally {
                if (token === this.campaigns_token) this.campaigns_loading = false
            }
        },
        // 기간을 바꾸면 그 기간에 없는 캠페인 선택은 비운다. 목록을 못 불러왔으면 판단할 수 없으니 비운다
        async onPeriodChange () {
            const loaded = await this.requestCampaigns()
            if (loaded === null) return
            if (!loaded || !(this.campaigns || []).some(_campaign => _campaign.id === this.projectInfo.campaign)) {
                this.projectInfo.campaign = null
            }
        },
        async requestPeriods () {
            try {
                const _res_periods = await this.$axios.get('/assessments/periods')
                this.periods = _res_periods.data
            } catch (error) {
                this.notifyLoadFailure(error, '기간 목록을 불러오지 못했습니다.')
            }
        },
        async requestClients () {
            try {
                const _res_clients = await this.$axios.get('/company/clients')
                const _clients = _res_clients.data
                this.client_by_project = _clients.map(({ company_name, company_id, company_code }) => ({ company_name, company_id, company_code }))
                this.clients_by_id = _clients.map(({ company_id, company_name }) => ({ company_id, company_name }))
            } catch (error) {
                this.notifyLoadFailure(error, '원청사 목록을 불러오지 못했습니다.')
            }
        },
        // project prop이 바뀔 때마다(다른 프로젝트 수정으로 전환 포함) AI 자동승인 상태를
        // 그 프로젝트 기준으로 다시 맞춘다. edit-project.vue 인스턴스는 모달 안에서 재사용되므로
        // created()에서 한 번만 불러오면 두 번째로 여는 프로젝트부터 이전 값이 남는다.
        async resetAiAutoApproveState (_target_project) {
            this.aiAutoApprove = false

            if (!this.edit || !this.can_manage_ai_auto_approve || !_target_project || !_target_project.project_code) {
                return
            }

            await this.requestAiAutoApproveStatus(_target_project)
        },
        async requestAiAutoApproveStatus (_target_project) {
            try {
                this.isLoadingAiAutoApprove = true
                const response = await this.$axios.get('/project_code/ai-auto-approve')
                const _projects = (response.data && response.data.projects) || []
                const _period = _target_project.period || this.project_period
                const _matched = _projects.find(_p =>
                    _p.project_code === _target_project.project_code && _p.period === _period
                )
                this.aiAutoApprove = !!(_matched && _matched.ai_auto_approve)
            } catch (error) {
                this.aiAutoApprove = false
                this.notifyLoadFailure(error, 'AI 자동승인 상태를 불러오지 못했습니다.')
            } finally {
                this.isLoadingAiAutoApprove = false
            }
        },
        // 켤 때만 확인 다이얼로그 — 끄는 건 안전한 방향이라 바로 반영한다(#189).
        // projectInfo 와 별개로 전용 엔드포인트를 즉시 호출해 저장한다("수정하기" 버튼과 무관).
        async onToggleAiAutoApprove (_next_value) {
            if (this.isSavingAiAutoApprove || this.isLoadingAiAutoApprove) {
                return
            }

            const code = `${this.project.project_code} (${this.project.period || this.project_period})`
            // 라디오는 :checked 단방향이라 취소·실패 시 key 를 바꿔 다시 그려 실제 값(aiAutoApprove)으로 되돌린다
            if (_next_value) {
                const is_confirm_ai_auto_approve = await this.$showModal({
                    type: 'confirm',
                    state: 'warning',
                    title: 'AI 자동승인 켜기',
                    message: `${code} 프로젝트의 AI 자동승인을 켭니다. 이후 AI 평가 결과가 평가자 확인 없이 바로 반영됩니다. 이 설정은 지금 바로 저장됩니다.`
                })
                if (!is_confirm_ai_auto_approve) {
                    this.aiRadioKey++
                    return
                }
            }

            try {
                this.isSavingAiAutoApprove = true
                await this.$axios.put(`/project_code/${this.project.project_code}/ai-auto-approve`, {
                    ai_auto_approve: _next_value
                })
                this.aiAutoApprove = _next_value
                this.$EventBus.$emit('toast-success', 'AI 자동승인', `${code} 자동승인을 ${_next_value ? '켰' : '껐'}습니다 (즉시 저장됨)`)
            } catch (error) {
                this.aiRadioKey++
                if (error?.response?.status === 401) {
                    return
                }
                this.$EventBus.$emit('toast-failure', 'AI 자동승인', 'AI 자동승인 설정을 저장하지 못했습니다.')
            } finally {
                this.isSavingAiAutoApprove = false
            }
        },
    }
}
</script>

<style>
</style>